function ProgressBar(props) {
    const className =
        props.shrinkForNextButton
        ? "progress-bar shrink-for-next-button"
        : "progress-bar";

    return (
        <div className={className}>
            <progress value={props.percentComplete} max="100">{props.percentComplete}</progress>
            <div className="progress-bar-value">{props.percentComplete}%</div>
        </div>
    );
}

export default ProgressBar;